/* eslint-disable no-console */

export const logger = {
  log: (...data) => {
    if (localStorage.getItem('mr-debug')) {
      console.log(...data);
    }
  },
  Debug: (...data) => {
    if (localStorage.getItem('mr-debug')) {
      console.log('[DEBUG]', data);
    }
  },
};
